import React, { FC, Suspense } from 'react'

import { useTypedSelector } from '@hooks/common/useTypedSelector'

import { lazyImport } from '@utils/lazyImport'

const { ConfirmExitPay } = lazyImport(
  () =>
    import(
      /*webpackChunkName: 'confirm-exit-pay'*/ '@components/Dialogs/ConfirmExitPay/ConfirmExitPay'
    ),
  'ConfirmExitPay'
)

export const LazyConfirmExitPay: FC = () => {
  const isOpened = useTypedSelector(
    (state) => state.dialogs.confirm.exitPay.isOpened
  )

  return <Suspense fallback={null}>{isOpened && <ConfirmExitPay />}</Suspense>
}
